import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import FetchHelper from '../../helpers/fetch_helper';
import JsonViewer from './jsonviewer';

const Snapshot = () => {
  const view = useSelector((state) => state.view);

  const [snapshot, setSnapshot] = useState(null);
  const [formFields, setFormfields] = useState(null);

  useEffect(() => {
    (async () => {
      const snap = await FetchHelper.fetchJson(`customers/${view?.id}/proposals/snapshots`, {
        method: 'GET',
        version: '/v3',
      });
      const form = await FetchHelper.fetchJson(`customers/${view?.id}/documents/snapshot/dry-run/form-field-values`, {
        method: 'POST',
        body: snap?.results[0],
        version: '/qa',
      });
      setFormfields(form);
      setSnapshot(snap);
    })();
  }, [view?.id]);

  console.log('formFields', formFields);
  console.log('snapshot', snapshot);
  // Additional styles for the app container
  const appStyles = {
    container: {
      maxWidth: '64rem',
      margin: '0 auto',
      padding: '1rem',
    },
    title: {
      fontSize: '1.25rem',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    inputContainer: {
      marginBottom: '1rem',
    },
    label: {
      display: 'block',
      marginBottom: '0.5rem',
      fontWeight: '500',
    },
    textarea: {
      width: '100%',
      height: '12rem',
      padding: '0.5rem',
      border: '1px solid #d1d5db',
      borderRadius: '0.25rem',
      fontFamily: 'monospace',
      fontSize: '0.875rem',
    },
    error: {
      color: '#dc2626',
      marginTop: '0.5rem',
    },
    outputTitle: {
      fontWeight: '500',
      marginBottom: '0.5rem',
    },
    outputContainer: {
      border: '1px solid #d1d5db',
      borderRadius: '0.25rem',
      padding: '1rem',
      backgroundColor: '#f9fafb',
    },
  };

  return (
    <div style={appStyles.container}>
      <table>
        <tr>
          <td>
            <h1 style={appStyles.title}>Mongo SnapShot</h1>
            <div>
              <div style={appStyles.outputContainer}>
                <JsonViewer data={snapshot?.results?.[0]} />
              </div>
            </div>
          </td>
          <td style={{ verticalAlign: 'top' }}>
            <h1 style={appStyles.title}>Form Fields</h1>
            <div>
              <div style={appStyles.outputContainer}>
                <JsonViewer data={formFields?.results?.[0]} />
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  );
};

export default Snapshot;
